import { ModalComponent } from '@app/core/ui/modal/modal.component';
import { NgModuleRef } from '@angular/core';

export class ModalOptions {
  private _modalComponent: any;
  public get modalComponent(): string {
    return this._modalComponent;
  }
  public moduleRef: NgModuleRef<any>;
  public hostedComponent: any;
  public datas: any;
  public title: string;
  public type: string;

  constructor() {
    this._modalComponent = ModalComponent;
  }
}
